var _defs, _rect, _circle, _circle2, _circle3, _circle4, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanCard2Months(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 520,
    viewBox: "0 0 800 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: 0,
    y1: 0,
    x2: 800,
    y2: 520,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B21E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C62828"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    rx: 26,
    fill: "url(#bg2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 238,
    r: 186,
    fill: "#7A1633",
    fillOpacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 238,
    r: 150,
    stroke: "#5B0F27",
    strokeWidth: 34,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 238,
    r: 150,
    stroke: "#FFE4EF",
    strokeWidth: 34,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "210 1000",
    transform: "rotate(-52 400 238)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 238,
    r: 150,
    stroke: "#FFE4EF",
    strokeWidth: 34,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "70 1000",
    transform: "rotate(132 400 238)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 214,
    textAnchor: "middle",
    fill: "#FFEDEA",
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 76,
    fontWeight: 700
  }, "2")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 268,
    textAnchor: "middle",
    fill: "#FFE3DF",
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 600,
    letterSpacing: 4
  }, "MONTHS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCard2Months);
export default __webpack_public_path__ + "static/media/plan-card-2months.53ccf728d4e9d4abaf821eada3082597.svg";
export { ForwardRef as ReactComponent };